import cn from 'classnames';

import ResponsiveImage from '@/components/utility/ResponsiveImage/ResponsiveImage';

import css from './HeroImage.module.css';

interface IHeroImage {
  heroImage: string;
  className?: string;
}

export const HeroImage = ({ heroImage, className }: IHeroImage) => {
  return (
    <div className={cn('w-full rounded-xl', css.heroImage, className)}>
      <ResponsiveImage
        src={heroImage}
        className="object-cover w-full max-h-[330px] rounded-2xl"
        fetchPriority="high"
        priority
      />
    </div>
  );
};
